export default __webpack_public_path__ + "static/videobg-96d3bec5d498c437ff6ed4506d8bd593.jpg";